window.addEventListener('load', function() {
  let swiperOptions = {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: false,
      breakpoints: {
        // when window width is >= 750px
        750: {
          slidesPerView: 2.3,
          spaceBetween: 30
        },
        // when window width is >= 990px
        990: {
          slidesPerView: 3,
          spaceBetween: 50
        },
  }
};
  
  const blogsSlider = new Swiper('.blogsSlider', swiperOptions);
});